export default "__VITE_ASSET__OGgKapTZ__"